import styled from 'styled-components';

interface StyledPromptSuggestionListItemProps {
  $color: string;
}

const StyledPromptSuggestionListItem = styled.div<StyledPromptSuggestionListItemProps>`
  text-align: center;

  .item {
    border: 1px solid ${(props) => props.$color};
    color: ${(props) => props.$color};
    font-size: 16px;
    padding: 6px 14px;
    border-radius: 50px;
    text-align: center;
    cursor: pointer;
    display: inline-block;
  }
`;

export default StyledPromptSuggestionListItem;